var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-nav'),_c('sidebar'),_c('router-view',{key:_vm.$route.path}),_c('audio',{ref:"notificationSound",staticClass:"soc_test select-none",attrs:{"controls":""}},[_c('source',{attrs:{"src":require("@/assets/sounds/message_sent2.wav"),"type":"audio/wav"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }